import { IRON, WHITE_BACKGROUND } from 'styles/Colors';
import BaseNavigation from 'portal/BaseNavigation';
import React from 'react';

const boxStyle = {
  '@media screen and (min-width: 50em)': {
    display: 'none'
  },

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  backgroundColor: WHITE_BACKGROUND,
  borderTop: `${IRON} solid 1px`,
  height: '4rem',
  position: 'sticky',
  bottom: 0,
  width: '100%',
  zIndex: 1000,

  hr: {
    borderLeft: `${IRON} solid 1px`,
    height: '1.75rem',
    margin: 0
  },

  svg: {
    transform: 'scale(1.5)'
  }
};

function Tabs({ navigate }) {
  return (
    <BaseNavigation
      navigate={navigate}
      containerId='mobileTabs'
      style={boxStyle}
      mobile
    />
  );
}

export default Tabs;
